import { initReactI18next } from 'react-i18next';

import i18next from 'i18next';

import translationsEn from './translations/en/translation.json';
import translationsIt from './translations/it/translation.json';

i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translation: translationsEn,
    },
    it: {
      translation: translationsIt,
    },
  },
  interpolation: {
    escapeValue: false,
  },
  // Re-render translated components when resources are added at runtime (the catalogue
  // labels registered from the menu, helpers/registerCatalogueLabels).
  react: {
    bindI18nStore: 'added',
  },
});

export { i18next };
